var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-md-block"},[_c('button',{staticClass:"btn bg-info float-right mr-0",on:{"click":function($event){return _vm.move(  _vm.BlockId, 'down' )}}},[_c('i',{staticClass:"fas fa-arrow-down"})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-420e5900","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MoveBlockButtons.vue
// module id = LWq9
// module chunks = 0